import type { MailParams } from '@webapp/account/src/resources/mailing/mailing';

import { mjmlHtml, mjmlTemplate } from './mjml';

// eslint-disable-next-line @typescript-eslint/no-var-requires
// const resetCss = require('!!raw-loader!!@webapp/common/assets/styles/normalize.css').default;
const resetCss = `
a {
    text-decoration: none;
}`;

// eslint-disable-next-line @typescript-eslint/no-var-requires
const wysiwygCss = require('!!raw-loader!!@webapp/common/assets/styles/wysiwyg.css').default;

const emailStyles = `
    /* reset */
    ${resetCss}
    /* wysiwyg */
    ${wysiwygCss}
`;

export const getMjmlHtmlCode = (params: MailParams, preview?: boolean): string =>
    mjmlTemplate(params, emailStyles, preview);

export const getFullHtmlCode = (body: string, preview: boolean): string => mjmlHtml(body, emailStyles, preview);
